module.exports = __webpack_public_path__ + "img/fallback.e277ad55.svg";